'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _fromEvent = require('rxjs/observable/fromEvent');

var _Observable = require('rxjs/Observable');

var _of = require('rxjs/observable/of');

var _from = require('rxjs/observable/from');

var _operators = require('rxjs/operators');

var _poller = require('../utils/poller');

var _poller2 = _interopRequireDefault(_poller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseSelector = function (_EventEmitter) {
  (0, _inherits3.default)(BaseSelector, _EventEmitter);

  function BaseSelector() {
    (0, _classCallCheck3.default)(this, BaseSelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseSelector.__proto__ || Object.getPrototypeOf(BaseSelector)).call(this));

    _this._eventsMap = {};
    _this.setMaxListeners(Number.MAX_VALUE);

    _this.dataBindings = _this.inputs;
    _this.eventBindings = _this.outputs;
    return _this;
  }
  /**
   * emitter = {
   *  eventName,
   *  trigger,
   *  stream,
   *  source,
   *  remove,
   *  subscription
   * }
   */


  (0, _createClass3.default)(BaseSelector, [{
    key: '_getEmitter',
    value: function _getEmitter(eventName) {
      var _arguments = arguments,
          _this2 = this;

      var emitter = this._eventsMap[eventName];
      var emitevent = 'subscribe.' + eventName;

      if (!emitter) {
        this._eventsMap[eventName] = emitter = {
          eventName: eventName
        };
        /**
         * ### action调用逻辑
         *
         * ```
         *  const selector = new Selector();
         *  const emitter = selector.fromEvent('increment', (stream) => {
         *    return stream.flatMap(num => {
         *      return new Promise(resolve => {
         *        setTimeout(() => {
         *          resolve(num + 1);
         *        });
         *      });
         *    });
         *  });
         * // 方式1
         * emitter.trigger(1, (res) => console.log(res)) // => 2
         * // 方式2
         * emitter.once(res => console.log(res)); // => 2
         * emitter.trigger(1);
         * ```
         */
        emitter.trigger = function () {
          var onceCallback = _arguments[_arguments.length - 1];
          if (typeof onceCallback === 'function') {
            _arguments.pop();
            // #! 轮询的处理
            if (emitter.source.polling) {
              var pollingCallback = function pollingCallback() {
                if (onceCallback.apply(undefined, arguments) === false) {
                  _this2.removeListener(eventName, pollingCallback);
                }
              };
              _this2.on(eventName, pollingCallback);
            } else {
              _this2.once(eventName, onceCallback);
            }
          }
          _this2.emit.apply(_this2, [emitevent].concat(Array.prototype.slice.call(_arguments)));
        };
        emitter.stream = (0, _fromEvent.fromEvent)(this, emitevent);
      } else {
        emitter.remove();
      }
      return emitter;
    }
  }, {
    key: '_subscribe',
    value: function _subscribe(eventObj) {
      var _this3 = this;

      var stream = eventObj.source.pipe((0, _operators.catchError)(function (err) {
        _this3.emit(eventObj.eventName, err);
        // > see:
        // https://www.bennadel.com/blog/3046-experimenting-with-the-catch-operator-and-
        // s tream-continuation-in-rxjs-and-angular-2.htm
        return stream;
      }));

      eventObj.subscription = stream.subscribe(function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this3.emit.apply(_this3, [eventObj.eventName, null].concat(args));
      }, function (err) {
        _this3.emit(eventObj.eventName, err);
      });

      eventObj.remove = function () {
        eventObj.subscription.unsubscribe();
      };
    }

    /**
     * option = {
     *  status: {
     *    start,
     *    end
     *  },
     *  action,
     *  next,
     *  delay
     * }
     */

  }, {
    key: '_getPoller',
    value: function _getPoller(option) {
      // poller.start => promise
      var promise = option.action(option.start);

      var source = (0, _from.from)(promise).pipe((0, _operators.expand)(function (res) {
        promise = option.action(res);
        if (promise !== false) {
          if (promise instanceof _Observable.Observable) {
            return promise;
          } else {
            // #! 数据必须是对象或者promise
            return (0, _from.from)(promise).pipe((0, _operators.delay)(option.delay));
          }
        } else {
          if (option.end && option.end.then) {
            return (0, _of.of)(option.end);
          } else {
            return (0, _of.of)(Promise.resolve(option.end));
          }
        }
      })).pipe((0, _operators.takeWhile)(function (res) {
        return option.hasTick(res);
      }));
      // #! 标记有轮询
      source.polling = true;
      return source;
    }

    /**
     * ### BaseSelector的Api
     *
     * | 方法 | 参数类型 | 描述 |
     * |: ------ |: ------ |: ------ |
     * | fromPoller(option) `Observable` | | |
     * | fromEvent(eventName, getSource) `Object` | | |
     * | unsubscribe(eventName) | | |
     */

  }, {
    key: 'fromPoller',
    value: function fromPoller(option) {
      if (option instanceof _poller2.default) {
        var poller = option;
        poller.stop();
        option = {
          start: {},
          end: {},
          delay: poller._option.delay,
          action: function action(res) {
            if (res === option.start) {
              return poller._current || poller.tick();
            } else {
              if (option.hasTick(res)) {
                return poller.tick();
              }
            }
          },
          hasTick: function hasTick(res) {
            return res !== option.end && poller.hasTick(res);
          }
        };
        return this._getPoller(option);
      } else {
        var newOption = {
          start: {},
          end: {},
          delay: option._delay,
          action: function action(res) {
            if (res === option.start && res !== option.end) {
              return option.action(res);
            }
          },
          hasTick: function hasTick(res) {
            return res === option.start && res !== option.end;
          }
        };
        return this._getPoller(newOption);
      }
    }
  }, {
    key: 'fromEvent',
    value: function fromEvent(eventName, getSource) {
      var emitter = this._getEmitter(eventName);

      // + 全局都加，避免combine过程中，stream调用多次 > see: see:
      // https://www.learnrxjs.io/operators/multicasting/cache.html
      var source = getSource(emitter.stream);
      if (source) {
        // emitter.source = source.cache(1);
        this._subscribe(emitter);
      }

      return emitter;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.removeAllListeners();
      for (var key in this._eventsMap) {
        this._eventsMap[key].subscription && this._eventsMap[key].subscription.unsubscribe();
      }
    }
  }]);
  return BaseSelector;
}(_events.EventEmitter);

exports.default = BaseSelector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/damo/baseSelector.js
// module id = 136
// module chunks = 0